import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemNutritionItem = (props: Props) => {
  const { label, value } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <BodyText sizeMatch={['14']} style={styles.text} numberOfLines={1}>
        {label}
      </BodyText>

      <BodyText sizeMatch={['14']} style={styles.text}>
        {value}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing['1'],
  },
  text: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  label: string;
  value: string | number;
};
